var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileArrowDownSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-arrow-down-solid 1",
    clipPath: "url(#clip0_177_23788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.125 0.5C0.95293 0.5 0 1.45293 0 2.625V15.375C0 16.5471 0.95293 17.5 2.125 17.5H10.625C11.7971 17.5 12.75 16.5471 12.75 15.375V5.8125H8.5C7.9123 5.8125 7.4375 5.3377 7.4375 4.75V0.5H2.125ZM8.5 0.5V4.75H12.75L8.5 0.5ZM7.17188 8.20312V11.5932L8.20117 10.5639C8.51328 10.2518 9.01797 10.2518 9.32676 10.5639C9.63555 10.876 9.63887 11.3807 9.32676 11.6895L6.93613 14.0801C6.62402 14.3922 6.11934 14.3922 5.81055 14.0801L3.41992 11.6895C3.10781 11.3773 3.10781 10.8727 3.41992 10.5639C3.73203 10.2551 4.23672 10.2518 4.54551 10.5639L5.5748 11.5932V8.20312C5.5748 7.76152 5.93008 7.40625 6.37168 7.40625C6.81328 7.40625 7.16855 7.76152 7.16855 8.20312H7.17188Z",
    fill: "#FFCABF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_23788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.75,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileArrowDownSolid);
export default __webpack_public_path__ + "static/media/file-arrow-down-solid.2171e17a82423b72518e29c201418c05.svg";
export { ForwardRef as ReactComponent };